itsoftApp.createModule("lazyLoadingImages", function() {
    var module = this;

    var initLazy = function () {
        itsoftApp.loadScript("assets/scripts/lazysizes/lazysizes.min.js", function() {
            window.lazySizesConfig = window.lazySizesConfig || {};
        });
    }

    initLazy();

    module.callback = initLazy;
});